var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04 9.75C7.14 9.75 5.59 8.2 5.59 6.3C5.59 4.4 7.14 2.85 9.04 2.85C10.94 2.85 12.49 4.4 12.49 6.3C12.49 8.2 10.94 9.75 9.04 9.75ZM9.04 4.35C7.97 4.35 7.09 5.22 7.09 6.3C7.09 7.38 7.96 8.25 9.04 8.25C10.12 8.25 10.99 7.38 10.99 6.3C10.99 5.22 10.12 4.35 9.04 4.35Z",
    fill: "currentColor",
    className: "accent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 18C7.68001 18 6.04001 15.52 4.90001 13.44C3.73001 11.31 2.48001 8.38 2.48001 6.52C2.48001 2.93 5.40001 0 9.00001 0C12.6 0 15.52 2.93 15.52 6.52C15.52 8.38 14.27 11.32 13.1 13.44C11.96 15.52 10.32 18 8.99001 18H9.00001ZM9.00001 1.5C6.23001 1.5 3.98001 3.75 3.98001 6.52C3.98001 9.54 7.87001 15.99 9.00001 16.49C10.13 15.99 14.02 9.55 14.02 6.52C14.02 3.75 11.77 1.5 9.00001 1.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.7269d5b9cce3dad9d627f4422b8f50a3.svg";
export { ForwardRef as ReactComponent };